import React, { useCallback } from 'react';

import {
  readAllNotifications,
  clearAllNotifications,
} from 'redux/reducers/notificationSlice';
import {
  notificationsSelector,
  firstNotificationIdSelector,
  unreadNotificationsCountSelector,
} from 'redux/selectors/notificationSelectors';
import BaseAlert from 'components/wrappers/BaseAlert';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useAppSelector } from 'hooks/useAppSelector';
import { isAdminSelector } from 'redux/selectors/authenticationSelectors';

import styles from '../HeaderNotifications.module.less';

export default function NotificationListHeader() {
  const dispatch = useAppDispatch();
  const notifications = useAppSelector(notificationsSelector);
  const unreadNotificationsCount = useAppSelector(
    unreadNotificationsCountSelector,
  );
  const firstNotificationId = useAppSelector(firstNotificationIdSelector);
  const isAdmin = useAppSelector(isAdminSelector);

  const handleReadAllNotifications = useCallback(async () => {
    if (!firstNotificationId) return;


    const result = await dispatch(readAllNotifications({ notificationId: firstNotificationId , isUserAdmin: isAdmin}));

    if (!readAllNotifications.fulfilled.match(result)) {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
  }, [dispatch, firstNotificationId, isAdmin]);

  const handleClearAllNotifications = useCallback(async () => {
    if (!firstNotificationId) return;

    const result = await dispatch(clearAllNotifications({ notificationId: firstNotificationId, isUserAdmin: isAdmin }));

    if (!clearAllNotifications.fulfilled.match(result)) {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
  }, [dispatch, firstNotificationId, isAdmin]);

  const renderHeaderButtons = () => {
    if (!notifications.length) return null;

    return !!unreadNotificationsCount ? (
      <div
        className={styles.notifyPopoverButton}
        onClick={handleReadAllNotifications}
      >
        Read all
      </div>
    ) : (
      <div
        className={styles.notifyPopoverButton}
        onClick={handleClearAllNotifications}
      >
        Clear all
      </div>
    );
  };

  return (
    <div className={styles.notifyPopoverHead}>
      <span className="icon icon-ring-outline" />

      <div className={styles.notifyPopoverTitle}>Notifications</div>

      <div className={styles.notifyPopoverButtonBox}>
        {renderHeaderButtons()}
      </div>
    </div>
  );
}
